import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { IssueItem } from '@models/Sessions/Idea/podcast-api';
import { CheckboxModule } from 'primeng/checkbox';
import { PaginatorModule } from 'primeng/paginator';

interface Form {
  selectedProblems: FormArray<FormControl<boolean>>;
}

@Component({
  selector: 'app-problems-list',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CheckboxModule, PaginatorModule],
  templateUrl: './problems-list.component.html',
  styleUrl: './problems-list.component.scss',
})
export class ProblemsListComponent implements OnInit {
  @Input() problems: IssueItem[];
  @Input() pageSize = 3;
  @Input() pageLinkSize = 3;

  page: IssueItem[] = [];
  pageIndex = 0; // Current page start index

  private formBuilder = inject(FormBuilder);
  private formControls = new Map<string, FormControl>();

  form = this.formBuilder.group<Form>({
    selectedProblems: this.formBuilder.array<boolean>([]),
  });

  get selectedProblems() {
    return this.form.get('selectedProblems') as FormArray<FormControl<boolean>>;
  }

  get isAnyProblemSelected() {
    return this.selectedProblems.value.some(Boolean);
  }

  ngOnInit() {
    this.createForm();
    this.updateCurrentPageItems();
  }

  formControl(problem: IssueItem) {
    return this.formControls.get(problem.instruction);
  }

  formSerialize() {
    return this.problems.filter((_, i) => this.selectedProblems.at(i).value);
  }

  private createForm() {
    this.problems.forEach((problem, idx) => {
      const control = this.formBuilder.control<boolean>(false);
      this.formControls.set(problem.instruction, control);
      this.selectedProblems.push(control);
    });
  }

  // Handle page change event
  onPageChange(event: any) {
    this.pageIndex = event.first;
    this.updateCurrentPageItems();
  }

  // Update items for current page
  updateCurrentPageItems() {
    const startIndex = this.pageIndex;
    const endIndex = this.pageIndex + this.pageSize;
    this.page = this.problems.slice(startIndex, endIndex);
  }
}
